var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlankProjectIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 118,
    viewBox: "0 0 59 118",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_330_4447)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.7812 19.25H37V1.4375C37 0.929688 36.5703 0.5 36.0625 0.5H22.9375C22.3906 0.5 22 0.929688 22 1.4375V19.25H21.2188C20.9453 19.25 20.75 19.4844 20.75 19.7188V20.5H38.25V19.7188C38.25 19.4844 38.0156 19.25 37.7812 19.25ZM25.75 3.46875C25.75 3.23438 25.9453 3 26.2188 3H27.7812C28.0156 3 28.25 3.23438 28.25 3.46875V5.03125C28.25 5.30469 28.0156 5.5 27.7812 5.5H26.2188C25.9453 5.5 25.75 5.30469 25.75 5.03125V3.46875ZM25.75 7.21875C25.75 6.98438 25.9453 6.75 26.2188 6.75H27.7812C28.0156 6.75 28.25 6.98438 28.25 7.21875V8.78125C28.25 9.05469 28.0156 9.25 27.7812 9.25H26.2188C25.9453 9.25 25.75 9.05469 25.75 8.78125V7.21875ZM27.7812 13H26.2188C25.9453 13 25.75 12.8047 25.75 12.5312V10.9688C25.75 10.7344 25.9453 10.5 26.2188 10.5H27.7812C28.0156 10.5 28.25 10.7344 28.25 10.9688V12.5312C28.25 12.8047 28.0156 13 27.7812 13ZM30.75 19.25H28.25V15.9688C28.25 15.7344 28.4453 15.5 28.7188 15.5H30.2812C30.5156 15.5 30.75 15.7344 30.75 15.9688V19.25ZM33.25 12.5312C33.25 12.8047 33.0156 13 32.7812 13H31.2188C30.9453 13 30.75 12.8047 30.75 12.5312V10.9688C30.75 10.7344 30.9453 10.5 31.2188 10.5H32.7812C33.0156 10.5 33.25 10.7344 33.25 10.9688V12.5312ZM33.25 8.78125C33.25 9.05469 33.0156 9.25 32.7812 9.25H31.2188C30.9453 9.25 30.75 9.05469 30.75 8.78125V7.21875C30.75 6.98438 30.9453 6.75 31.2188 6.75H32.7812C33.0156 6.75 33.25 6.98438 33.25 7.21875V8.78125ZM33.25 5.03125C33.25 5.30469 33.0156 5.5 32.7812 5.5H31.2188C30.9453 5.5 30.75 5.30469 30.75 5.03125V3.46875C30.75 3.23438 30.9453 3 31.2188 3H32.7812C33.0156 3 33.25 3.23438 33.25 3.46875V5.03125Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 28,
    width: 59,
    height: 90,
    rx: 7,
    fill: "#FAFAFA",
    stroke: "#DDDDDD",
    strokeWidth: 0.86
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 37,
    width: 46,
    height: 20,
    rx: 3,
    fill: "#C5C5C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1875 44.9688H29.9688V40.75C29.9688 40.252 29.5293 39.8125 29.0312 39.8125H28.0938C27.5664 39.8125 27.1562 40.252 27.1562 40.75V44.9688H22.9375C22.4102 44.9688 22 45.4082 22 45.9062V46.8438C22 47.3711 22.4102 47.7812 22.9375 47.7812H27.1562V52C27.1562 52.5273 27.5664 52.9375 28.0938 52.9375H29.0312C29.5293 52.9375 29.9688 52.5273 29.9688 52V47.7812H34.1875C34.6855 47.7812 35.125 47.3711 35.125 46.8438V45.9062C35.125 45.4082 34.6855 44.9688 34.1875 44.9688Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_330_4447"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 59,
    height: 118,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlankProjectIcon);
export default __webpack_public_path__ + "static/media/blank_project_icon.0abe1d17.svg";
export { ForwardRef as ReactComponent };